export default "__VITE_PUBLIC_ASSET__8057d5e1__"